module.exports = __webpack_public_path__ + "img/loginimg.20af7f0e.jpg";